"use client";

import CustomFieldSubtitle from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomFieldSubtitle";
import type { AutocompleteOption } from "@/components/common/formElements/hooks/useAutocompleteFieldController";
import type { HTMLAttributes } from "react";

export function renderAutocompleteOption(
  props: HTMLAttributes<HTMLLIElement> & {
    key?: string;
  },
  option: AutocompleteOption & {
    isHeading?: boolean;
    level?: number;
    disabled?: boolean;
  },
) {
  const { key, ...restProps } = props;

  const style = {
    paddingLeft:
      option.level && option.level > 0 ? `${option.level * 16 + 16}px` : "16px",
  };

  return (
    <li key={key} {...restProps} style={{ ...restProps.style, ...style }}>
      {option.isHeading ? (
        <CustomFieldSubtitle label={option.label} />
      ) : (
        option.label
      )}
    </li>
  );
}
